import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

export interface MaterialBalanceItem {
  material_id: string;
  material_nombre: string;
  material_sku: string | null;
  material_unidad: string;
  material_categoria: string;
  total_ot: number;
  total_pedido: number;
  pendiente: number;
  excede_ot: boolean;
}

export function useMaterialBalance(projectId: string) {
  return useQuery({
    queryKey: queryKeys.materialBalance.byProject(projectId),
    queryFn: async () => {
      const res = await api.get<{ data: MaterialBalanceItem[] }>(
        `/projects/${projectId}/material-balance`,
      );
      return res.data.data;
    },
    enabled: !!projectId,
  });
}
